import { render, staticRenderFns } from "./ChampionSelector.vue?vue&type=template&id=e4a380ac&"
import script from "./ChampionSelector.vue?vue&type=script&lang=js&"
export * from "./ChampionSelector.vue?vue&type=script&lang=js&"
import style0 from "./ChampionSelector.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports